import { descriptions } from 'constants/descriptions'

export const AUTOMATIC_APY_CALCULATION = {
  name: 'APY',
  longDescription: descriptions.apy,
}
